import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { ProvidersServices } from "../../../providers/services";
import { IngredientsServices } from "../../../ingredients/services";
import { ProductsServices } from "../../../products/services";
import { Globals } from "../../../../globals";
import { StaticsServices } from '../../../services/statics';
import { DeliberyNoteServices } from '../../../delibery_note/services';
import { IncomeExpensesServices } from '../../services';
import { IncomeExpensesListPage } from '../../income-expenses-list/income-expenses-list';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the DeliberyNoteCreateIngprodPricePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-expenses-deno-create-separate-percetage',
  templateUrl: 'expenses-deno-create-separate-percetage.html',
})
export class ExpensesDenoCreateSeparatePercetagePage {
  term: string;
  number: any;
  date: any;
  products: any;
  business_name: any;
  provider_uid: any;
  payment_method: any;
  category: any;
  payment: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public providersServices: ProvidersServices,
    public deliberyNoteServices: DeliberyNoteServices,
    public ingredientsServices: IngredientsServices,
    public productsServices: ProductsServices,
    public globals: Globals,
    public staticsServices: StaticsServices,
    public incomeExpensesServices: IncomeExpensesServices,
    public translate: TranslateService) {

    this.number = this.navParams.get('number');
    this.date = this.navParams.get('date');
    this.business_name = this.navParams.get('business_name');
    this.provider_uid = this.navParams.get('provider_uid');
    this.payment_method = this.navParams.get('payment_method');
    this.category = this.navParams.get('category');
    this.payment = this.navParams.get('payment');

    //calculem per taxes els conceptes de tots el albarans seleccionats.
    this.separateTaxPercetage();
  }

  public array = Array();
  separateTaxPercetage() {
    this.array = Array()
    for (let deno of this.deliberyNoteServices.delibery_notes_array_tmp) {//albaranes seleccionados en pantalla previa
      for (let list of deno[2]) {//list in deno
        //si array esta buit
        if (this.array.length == 0) {
          this.array.push({
            tax: list.tax,
            total: list.total,
            base: this.calculateNotax(list.price, list.quantity, list.discount),//func que calcula base amb descompte
            concept: 'Albarán/es: ' + deno[3],
          });

        } else {
          //busca si existeix o no
          var index = this.array.findIndex(e => e.tax === list.tax);
          if (index >= 0) {
            //calcula i suma total base al array
            this.array[index].total += list.total;
            this.array[index].base += this.calculateNotax(list.price, list.quantity, list.discount);//func retorna preu sense calcul iva

            //si concepte no esta en string afegir
            var str = this.array[index].concept;
            if (str.indexOf(deno[3]) == -1) {
              this.array[index].concept = this.array[index].concept + ' ' + deno[3];
            }


          } else {
            //afegeix element al array
            this.array.push({
              tax: list.tax,
              total: list.total,
              base: this.calculateNotax(list.price, list.quantity, list.discount),
              concept: 'Albarán/es: ' + deno[3],
            });
          }
        }
      }
    }
  }

  calculateNotax(price, quantity, discount) {
    var _base = price * quantity;
    return _base - ((_base * discount) / 100);

  }

  ionViewWillLeave() {
    if (this.next == false) {
      this.deliberyNoteServices.delibery_notes_array_tmp = Array();
    }
  }

  public next: boolean = false;
  async insertExpenses() {
    this.next = true;
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-generando-gastos')
    });
    loadingPopup.present();
    //recorem per taxes
    for (let list of this.array) {
      // Calcular IRPF (siempre 0 en este caso, pero mantenemos consistencia)
      var irpf_perc = 0;
      var irpf_amt = 0;
      
      // Calcular IVA sobre la base original
      var tax_amount = (list.base * list.tax) / 100;
      
      // Calcular total: Base + IVA - IRPF (consistente con calculateRow())
      // Aunque IRPF sea 0, usamos la misma fórmula que en calculateRow()
      var calculated_total = list.base + tax_amount - irpf_amt;
      
      //insertem gasto per cada taxa
      this.incomeExpensesServices.afs.collection('expenses').add({
        'UID_RESTAURANT': this.globals.restaurant_uid,
        'number': this.number,
        'date': new Date(this.date),
        'concept': list.concept,
        'base': list.base,
        'tax': list.tax,
        'total': calculated_total,
        'business_name': this.business_name,
        'provider_uid': this.provider_uid,
        'payment_method': this.payment_method,
        'category': this.category,
        'payment': this.payment,
        'irpf_percentage': irpf_perc,
        'irpf_amount': irpf_amt
      }).then(doc => {
      });
    }
    //recorem denos per marcar deno tancada
    await this.deliberyNoteServices.deleteDeliberyNotes(this.deliberyNoteServices.delibery_notes_array_tmp);
    //reset
    this.deliberyNoteServices.delibery_notes_array_tmp = Array();
    //
    this.globals.GAtrackView('ProviderOrders', 'ProviderOrders - Separate percetages - Create', this.globals.restaurant.email, 'Create/Update', 'Create provider order separate percetages', 'ProviderOrders', this.number);
    //al acabar setroot a pagina de ingresos i gastos
    this.globals.side_menu_active = 'inexp';
    this.navCtrl.setRoot(IncomeExpensesListPage);

    loadingPopup.dismiss();

  }



}



// WEBPACK FOOTER //
// ./src/pages/income-expenses/expenses-deno-create/expenses-deno-create-separate-percetage/expenses-deno-create-separate-percetage.ts